import { useCallback } from "react";
import { prepareWriteContract, writeContract } from "wagmi/actions";
import { Address, Hash } from "viem";
import { GlobalStore } from "../store/global/GlobalStore";
import { getWrappedTokenAddress } from "../utils/chainUtils";
import { usePublicClient, useWalletClient } from "wagmi";
import { WRAPPED_ABI } from "../config/consts";

export const useWrap = () => {
  const { data: walletClient } = useWalletClient();
  const publicClient = usePublicClient();
  const { wrapQuote, network, address } = GlobalStore.useState(s => {
    return {
      wrapQuote: s.wrapQuote,
      network: s.network,
      address: s.address,
    };
  });

  return useCallback(
    async (amount: bigint) => {
      const wrappedToken = getWrappedTokenAddress(network);
      let txHash: Hash | undefined = undefined;
      if (!wrapQuote || !walletClient) {
        throw new Error(
          `Could not find: ${!wrapQuote ? "quote," : ""} ${!walletClient ? "wallet" : ""}`
        );
      }
      if (network.id !== walletClient.chain.id && network.id !== publicClient.chain.id) {
        throw new Error(`Wrong network`);
      }
      if (wrapQuote.type === "Wrapping") {
        const config = await prepareWriteContract({
          address: wrappedToken,
          account: address as Address,
          abi: WRAPPED_ABI,
          functionName: "deposit",
          chainId: network.id, // Important - this binds the contract to the correct network
          value: amount,
        });
        const { hash } = await writeContract({ ...config, chainId: network.id });
        txHash = hash;
      } else {
        //TODO TOKENS: FIX WRAPPED/UNWRAPED TOKEN ADDRESS
        const config = await prepareWriteContract({
          address: wrappedToken,
          account: address as Address,
          abi: WRAPPED_ABI,
          functionName: "withdraw",
          chainId: network.id, // Important - this binds the contract to the correct network
          args: [amount],
        });
        const { hash } = await writeContract({ ...config, chainId: network.id });
        txHash = hash;
      }

      return txHash;
    },
    [network, wrapQuote, walletClient, publicClient.chain.id, address]
  );
};
